$(window).on('load', function (e) {
    var isIE = false;
    var ua = window.navigator.userAgent;
    var old_ie = ua.indexOf('MSIE ');
    var new_ie = ua.indexOf('Trident/');
    if ((old_ie > -1) || (new_ie > -1)) {
        isIE = true;
    }
    if ( isIE ) {
        $('body').addClass('user-agent-ie');
        let selectOffers = $('.section-subscribe-wipes').find('.subscribe-option-boxes').addClass('hide').next().removeClass('hide');
        selectOffers.find('select').prepend('<option value="0" selected>none</option>');
    }
    /**** SUBSCRIPTION PAGE (CREATE SUBSCRIPTION) ****/

    /*** Add nappies ***/

    /** Add main nappies pack **/

    /* Check if both options (size and style) are checked - for main nappies pack */
    /* and set data-attributes for '.subscription-product' container */
    var $window = $(window);
    var currentTotal = 0;
    var $addSubscriptionBtn = $('#add-subscription-btn');
    var confirmTable = $('.confirm_table');
    var $mainNappiesSection = $('.section-subscribe-main');
    var $mainNextBtn = $('.btn--next');
    var $mainPrevBtn = $('.btn--prev');
    var offersEnabled = $('.section-subscribe-offers').length ? true : false;
    var subscribeProducts = [];
    var headerBreadcrumbs = $('.subscribe-breadcrumbs_wrapper');
    var withABtest = $('.subscribe-page-older').length > 0 && $('.subscribe-page-older').hasClass('hide') ? true : false;

    function updateQueryStringParam(key, value) {
        var baseUrl = [location.protocol, '//', location.host, location.pathname].join(''),
            urlQueryString = document.location.search,
            newParam = key + '=' + value,
            params = '?' + newParam;
        if (urlQueryString) {
            var updateRegex = new RegExp('([\?&])' + key + '[^&]*');
            var removeRegex = new RegExp('([\?&])' + key + '=[^&;]+[&;]?');
            if( typeof value == 'undefined' || value == null || value == '' ) { // Remove param if value is empty
                params = urlQueryString.replace(removeRegex, "$1");
                params = params.replace( /[&;]$/, "" );
            } else if (urlQueryString.match(updateRegex) !== null) { // If param exists already, update it
                params = urlQueryString.replace(updateRegex, "$1" + newParam);
            } else { // Otherwise, add it to end of query string
                params = urlQueryString + '&' + newParam;
            }
        }
        params = params == '?' ? '' : params;
        window.history.replaceState({}, "", baseUrl + params);
    }

    function getQueryVariable(variable) {
        var query = window.location.search.substring(1);
        var vars = query.split('&');
        for (var i = 0; i < vars.length; i++) {
            var pair = vars[i].split('=');
            if (decodeURIComponent(pair[0]) == variable) {
                return decodeURIComponent(pair[1]);
            }
        }
        //console.log('Query variable %s not found', variable);
        return false;
    }

    if (headerBreadcrumbs.length > 0 || withABtest) {
        var headerBreadcrumbsOffset = headerBreadcrumbs.offset().top;
        var addStepName = $('.subscribe_step[data-step="1"]').attr('data-name');
        updateQueryStringParam('step', addStepName);

        var currentVariant = getQueryVariable('variant');
        if (currentVariant !== false && !$('.radio-size-wrapper.main-radio').find('[data-id="' + currentVariant + '"]').hasClass('label-disabled')) {
            $('.radio-size-wrapper.main-radio').find('[data-id="' + currentVariant + '"]').click();
            $('#ProductSelect').find('option[value="' + currentVariant + '"]').attr('selected', 'selected');
        }
    }

    /* Subscribe button position (fixed or normal)*/
    if (offersEnabled && $('.subscription-btn-wrapper').length > 0) {
        var footerOffsetUpdate = $('#shopify-section-footer').offset().top;
        var windowHeightUpdate = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
        changeButtonClassUpdate();
        $window.on('scroll', function () {
            changeButtonClassUpdate();
        });
        $window.on('resize', function () {
            footerOffsetUpdate = $('#shopify-section-footer').offset().top;
            windowHeightUpdate = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
            changeButtonClassUpdate();
        });
        function changeButtonClassUpdate() {
            if (!$('.subscription-btn-wrapper').hasClass('hide')) {
                if ($window.scrollTop() >= (footerOffsetUpdate - windowHeightUpdate)) {
                    $('.subscription-btn-wrapper').removeClass('active-btn');
                } else {
                    if ($addSubscriptionBtn.attr('disabled') !== 'disabled') {
                        $('.subscription-btn-wrapper').addClass('active-btn');
                    }
                }
            }
        }
    }

    var optionsNum = $mainNappiesSection.find('.single-option-radio').length;
    checkMainNappiesOptions();
    $mainNappiesSection.find('.single-option-selector__radio').on('change', function () {
        optionsNum = $mainNappiesSection.find('.single-option-radio').length;
        checkMainNappiesOptions();
    });

    function checkMainNappiesOptions() {
        var $thisContainer = $mainNappiesSection.find('.subscription-product');
        var $checkedOptions = $mainNappiesSection.find('.single-option-selector__radio:checked');
        var $variantSelect = $mainNappiesSection.find('.product-single__variants');
        if (optionsNum == 2 && $('.subscribe-page-older').length > 0) {
            optionsNum = optionsNum - 1;
        }
        //console.log('checkMainNappiesOptions', $checkedOptions.length, optionsNum, $variantSelect);
        if ($checkedOptions.length < optionsNum) {
            $addSubscriptionBtn.attr('disabled', 'disabled');
            $thisContainer.removeClass('subscription-product-active');
        } else {
            $addSubscriptionBtn.removeAttr('disabled');
            if (offersEnabled && $('.subscription-btn-wrapper').length > 0 && !$('.subscription-btn-wrapper').hasClass('hide')) {
                $('.subscription-btn-wrapper').addClass('active-btn');
            }
            if (headerBreadcrumbs.length > 0) {
                $mainNextBtn.removeClass('disabled').parent().prev().removeClass('hide');
                headerBreadcrumbs.find('.subscribe_step[data-step="2"]').removeClass('disabled');
            }
            changeButtonClass();
            var variantId = $variantSelect.val();
            var variantQnt = $variantSelect.find('option:selected').attr('data-subscribe-qnt');
            var variantPrice = parseInt($variantSelect.find('option:selected').attr('data-price'));
            $thisContainer.find('.qnt-input').val(variantQnt);
            $thisContainer.attr({
                'data-variant-id':    variantId,
                'data-variant-price': variantPrice
            }).addClass('subscription-product-active');

            if (window.location.pathname != '/cart') {
                updateQueryStringParam('variant', variantId);
            }
        }
        calcCurrentTotal();
    }

    /* Subscribe button position (fixed or normal) */
    changeButtonClass();
    $window.on('scroll', function () {
        changeButtonClass();
    });
    $window.on('resize', function () {
        if (headerBreadcrumbs.length > 0) {
            headerBreadcrumbsOffset = headerBreadcrumbs.offset().top;
        }
        changeButtonClass();
    });
    function changeButtonClass() {
        let footerOffset = $('#shopify-section-footer').offset().top;
        let windowHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
        let nextNavPseudo = $('.subscription-nav_wrapper').next();
        if ($window.scrollTop() >= (footerOffset - windowHeight)) {
            $('.subscription-nav_wrapper').removeClass('active-btn');
            if (headerBreadcrumbs.length > 0) {
                nextNavPseudo.addClass('hide').removeClass('max');
            }
        } else {
            $('.subscription-nav_wrapper').addClass('active-btn');
            if (headerBreadcrumbs.length > 0) {
                if (window.location.search.indexOf('step=confirm') > -1) {
                    nextNavPseudo.addClass('max');
                }
                nextNavPseudo.removeClass('hide');
            }
        }

        if (headerBreadcrumbs.length > 0) {
            if(headerBreadcrumbsOffset <= $window.scrollTop()){
                headerBreadcrumbs.addClass('fixed').parent().addClass('fix-height');
            } else {
                headerBreadcrumbs.removeClass('fixed').parent().removeClass('fix-height');
            }
        }
    }

    /* Add additional nappies */
    /* Check if both options (size and style) are checked - for additional nappies */
    /* for enabling/disabling 'Add' button */
    var $optionSelectors = $('.section-subscribe-nappies').find('.single-option-selector__radio').eq(0);
    //checkNappiesOptions();
    $optionSelectors.on('change', function () {
        let el = $(this);
        if (el.val() !== 'no_value') {
            el.parent().parent().find('.add-nappies-id').removeAttr('disabled').removeClass('disabled-btn');
        }
        //checkNappiesOptions();
    });
    function checkNappiesOptions() {
        var $addNappiesBtn = $('.add-nappies-id');
        var notSelected = 0;
        $optionSelectors.each(function () {
            if ($(this).val() == 'no_value') {
                notSelected++;
            }
        });
        //console.log('checkNappiesOptions', notSelected);
        if (notSelected > 0) {
            $addNappiesBtn.attr('disabled', 'disabled').addClass('disabled-btn');
        } else {
            $addNappiesBtn.removeAttr('disabled').removeClass('disabled').removeClass('disabled-btn');
        }
    }

    /* Add additional nappies (create div with data-attributes and qnt-input) */
    $('.add-nappies-id').on('click', function () {
        var $thisContainer = $('.section-subscribe-nappies:not(".hide")');
        var $template = $('.subscription-product-template').eq(0).clone();
        var $variantSelect = $thisContainer.find('.product-single__variants');
        var variantId = $variantSelect.val();
        var variantSelected = $variantSelect.find('option:selected');
        var variantTitle = variantSelected.text().split(' / ');
        var variantPrice = parseInt(variantSelected.attr('data-price'));
        var variantQnt = $thisContainer.find('.js-qty__num').val();
        var $variantAdded = $thisContainer.find('.subscription-product[data-variant-id=' + variantId + ']');
        var popupBlock = $template.find('.subscription-product-popup');
        variantSelected.attr('data-subscribe-qnt', variantQnt);
        if (variantQnt > 0) {
            if ($variantAdded.length > 0) {
                $variantAdded.find('.product-qnt').text(variantQnt);
                $variantAdded.find('.qnt-input').val(variantQnt);
                $variantAdded.find('.subscription-product-popup').fadeIn(800).delay(2000).fadeOut(800);
                $variantAdded.attr('data-subscribe-qnt', variantQnt);
            } else {
                if ($thisContainer.find('.grid--subscribed-title').hasClass('hide')) {
                    $thisContainer.find('.grid--subscribed-title').removeClass('hide');
                }
                $template.find('.product-option-1').text(variantTitle[0]);
                $template.find('.product-option-2').text(variantTitle[1]);
                $template.find('.product-qnt').text(variantQnt);
                $template.attr({
                    'data-variant-id':    variantId,
                    'data-variant-price': variantPrice
                });
                $template.find('.qnt-input').val(variantQnt);
                $template.appendTo('#added-nappies').removeClass('subscription-product-template').addClass('subscription-product-active');
                popupBlock.fadeIn(800).delay(2000).fadeOut(800);
                // setTimeout(function() {popupBlock.fadeOut(800)}, 2000);

                /* Remove nappies button action */
                $template.find('.btn-remove-product').on('click', function () {
                    $(this).closest('.subscription-product').remove();
                    calcCurrentTotal();
                    if ($thisContainer.find('.btn-remove-product').length == 1 && !$thisContainer.find('.grid--subscribed-title').hasClass('hide')) {
                        $thisContainer.find('.grid--subscribed-title').addClass('hide');
                    }
                });
            }
        }
        calcCurrentTotal();
    });

    $('.btn--to-next').on('click', function () {
        let el = $(this);
        let nextProduct = el.closest('.subscription-product').next();
        if (nextProduct.length == 0) {
            nextProduct = $('.section-subscribe-skincare');
        }
        $("html, body").animate({ scrollTop: nextProduct.offset().top - 77 }, 1000);
    });

    /* Remove nappies button action (when nappies have already exist in cart) */
    $('.btn-remove-product').on('click', function () {
        $(this).closest('.subscription-product').remove();
        calcCurrentTotal();
        if ($('.btn-remove-product').length == 1 && !$('.grid--subscribed-title').hasClass('hide')) {
            $('.grid--subscribed-title').addClass('hide');
        }
    });

    /* Calculate current total */
    function calcCurrentTotal() {
        currentTotal = 0;
        $('.subscription-product-active:not(".hide")').each(function () {
            let $this = $(this);
            let thisQnt = parseInt($this.find('.qnt-input').val());
            let thisPrice = parseInt($this.attr('data-variant-price'));
            if (thisQnt > 0) {
                currentTotal += thisQnt * thisPrice;
            }
        });
        //console.log('currentTotal', currentTotal);
        $('.current-total-sum').html(theme.Currency.formatMoney(currentTotal, theme.strings.moneyFormat));
        $('.current-frequency').text($('#shipping-frequency').val());
    }

    function addProductsToConfirm(option) {
        let subscriptionActiveProds = $('.subscription-product-active:not(".hide")');
        let subscriptionActiveLen = subscriptionActiveProds.length;
        confirmTable.find('.appended-item').remove();
        for (let i = 0; i < subscriptionActiveLen; i++) {
            let $this = $(subscriptionActiveProds[i]), variantSelect;
            if (!$this.hasClass('subscription-product-template')) {
                if ($this.find('.product-single__variants').length > 0) {
                    variantSelect = $this.find('select.product-single__variants').find('option:selected');
                } else {
                    if ($this.hasClass('grid--small') && $this.parent().attr('id') == 'added-nappies') {
                        variantSelect = $('.ProductSelect').find('option[value="' + $this.attr('data-variant-id') + '"]');
                    } else {
                        if ($this.find('.qnt-input').length > 0) {
                            $this.attr('data-subscribe-qnt', $this.find('.qnt-input').val());
                        }
                        variantSelect = $this;
                    }
                }
                addProductToConfirm(variantSelect);
            }
        }
    }
    function addProductToConfirm(o){
        let option = o[0];
        if (option.length == 0 && option.getAttribute('value') == undefined) {
            return false;
        }
        let title = option.getAttribute('data-subscribe-variant-title');
        let price = parseInt(option.getAttribute('data-price'));
        let qty = parseInt(option.getAttribute('data-subscribe-qnt'));
        let step = option.getAttribute('data-step');
        let row = confirmTable[0].getElementsByClassName('append-empty-item')[0];
        let newRow = row.cloneNode(true);
        newRow.setAttribute('variant-id', option.getAttribute('value'));
        newRow.classList.remove('append-empty-item');
        newRow.classList.add('appended-item');
        newRow.getElementsByTagName('img')[0].setAttribute('src', option.getAttribute('data-subscribe-variant-img'));
        newRow.getElementsByTagName('img')[0].setAttribute('alt', title);
        newRow.getElementsByTagName('img')[0].setAttribute('data-step-to', step);
        newRow.getElementsByClassName('cart__product-name')[0].setAttribute('data-step-to', step);
        newRow.getElementsByClassName('cart__product-name')[0].textContent = option.getAttribute('data-subscribe-title') + ' x ' + qty;
        newRow.getElementsByClassName('cart-product-options')[0].textContent = title;
        newRow.getElementsByClassName('cart__price')[0].textContent = theme.Currency.formatMoney((price * qty), theme.strings.moneyFormat);

        let frequency = document.getElementById('shipping-frequency');
        let frequencyStep = frequency.getAttribute('data-step');
        newRow.getElementsByClassName('cart__price-subscribe')[0].setAttribute('data-step-to', frequencyStep);
        newRow.getElementsByClassName('cart__price-subscribe')[0].textContent =  '/ ' + frequency.value;
        confirmTable[0].insertAdjacentHTML('beforeend', newRow.outerHTML);
    }

    confirmTable.on('click', '[data-step-to]', function () {
        let $this = $(this);
        let $thisStep = parseInt($this.attr('data-step-to'));
        if ($thisStep != NaN) {
            if ($thisStep == 1) {
                $('.subscribe_step[data-step="' + 3 + '"]').removeClass('active').prev().removeClass('active');
            }
            $('.subscribe_step[data-step="' + 4 + '"]').removeClass('active').prev().removeClass('active');
            $mainPrevBtn.attr('data-step', $thisStep - 1);
            goToStep($thisStep, 4);
            $mainNextBtn.attr('data-step', $thisStep);
        }
    });

    $('.single-option-boxes input[type="radio"]').on('change', function () {
        let thisRadio = $(this);
        thisRadio.addClass("imChecked").parent().siblings().find('input[type="radio"]').removeClass("imChecked");
        $('#' + thisRadio.attr('name')).val(thisRadio.val()).change();
    });

    $('.single-option-boxes input[type="radio"]').on('click', function () {
        let thisRadio = $(this);
        if (thisRadio.hasClass("imChecked")) {
            thisRadio.removeClass("imChecked");
            thisRadio.prop('checked', false);
            $('#' + thisRadio.attr('name')).val('').change();
        } else {
            thisRadio.prop('checked', true);
            thisRadio.addClass("imChecked");
        }
    });

    /* Change price in wipes and sacks section according to quantity */
    $('.section-subscribe-wipes .qnt-input').on('change', function () {
        let $thisContainer = $(this).closest('.subscription-product');
        let thisVal = $(this).val();
        let thisQnt = thisVal == null ? 0 : parseInt(thisVal);
        let thisPrice = parseInt($thisContainer.attr('data-variant-price'));
        let thisPriceContainer = $thisContainer.find('.subscription-product-total-price');
        if (thisQnt == 0){
            thisPriceContainer.addClass('hide').text('');
        } else {
            thisPriceContainer.text(theme.Currency.formatMoney((thisQnt * thisPrice), theme.strings.moneyFormat)).removeClass('hide');
        }
        otherOffers(thisQnt, $thisContainer);
    });

    /* Change total price when quantity is changing (if product is active) */
    $('.section-subscribe-skincare .subscription-product .qnt-input').on('change keyup', function () {
        let $this = $(this);
        if ($this.hasClass('js-qty__num-new')) {
            let thisVal = $this.val();
            let thisQnt = thisVal == null ? 0 : parseInt(thisVal);
            let $plusQnt = $this.siblings('.js-qty__adjust--plus').find('span');
            otherOffers(thisQnt, $this.closest('.subscription-product'));
            $plusQnt.text(thisQnt == 0 ? '+' : thisQnt);
        }
    });

    /* Add other products */
    $('.collection-products .subscription-product .subscription-product-label.old-design').on('click', function () {
        $(this).closest('.subscription-product').toggleClass('subscription-product-active');

        var popupBlock =  $(this).find('.subscription-product-popup');
        if ($(this).closest('.subscription-product').hasClass('subscription-product-active')) {
            popupBlock.fadeIn(800);
            setTimeout(function() {popupBlock.fadeOut(800)}, 2000);
        } else {
            popupBlock.css("display", "none");
        }
        calcCurrentTotal();
    });

    /* Add other products */
    function otherOffers (qty, $container) {
        //console.log('otherOffers', qty, $container);
        (qty == 0) ? $container.removeClass('subscription-product-active') : $container.addClass('subscription-product-active');
        calcCurrentTotal();
    }

    $('input[name="frequency"]').on('change', function () {
        $('#shipping-frequency').val($(this).val()).change();
    });

    $('#shipping-frequency').on('change', function () {
        $('.current-frequency').text($(this).val()).parent().addClass('with-frequency');
    });

    headerBreadcrumbs.find('.subscribe_step').on('click', function () {
        let btn = $(this),
            nextStep = parseInt(btn.attr('data-step')),
            currentStep = nextStep + 1,
            maxStep = parseInt($mainNextBtn.attr('data-max'));
        if (!btn.hasClass('disabled')) {
            $mainNextBtn.attr('data-step', nextStep);
            goToStep(nextStep, currentStep);
            $mainPrevBtn.attr('data-step', nextStep - 1);
            if (nextStep == maxStep) {
                $('.subscribe_step[data-step="' + 2 + '"]').addClass('active').prev().addClass('active');
                $('.subscribe_step[data-step="' + 3 + '"]').addClass('active').prev().addClass('active');
                $('.current-total').addClass('with-frequency');
                addProductsToConfirm();
                calcCurrentTotal();
            } else if (nextStep == maxStep - 1) {
                $('.subscribe_step[data-step="' + 2 + '"]').addClass('active').prev().addClass('active');
                $('.subscribe_step[data-step="' + maxStep + '"]').removeClass('disabled');
                $('.current-total').addClass('with-frequency');
            } else if (nextStep == maxStep - 2) {
                $('.subscribe_step[data-step="' + maxStep + '"]').removeClass('active').prev().removeClass('active');
                if ($('.subscribe_step[data-step="3"]').length == 0) {
                    $('.subscribe_step[data-step="' + maxStep + '"]').removeClass('disabled');
                } else {
                    $('.subscribe_step[data-step="' + (maxStep - 1) + '"]').removeClass('disabled');
                }
            } else {
                $('.subscribe_step[data-step="' + maxStep + '"]').removeClass('active').prev().removeClass('active');
                $('.subscribe_step[data-step="' + (maxStep - 1) + '"]').removeClass('active').prev().removeClass('active');
            }
        }
    });

    $mainNextBtn.on('click', function () {
        let btn = $(this),
            currentStep = parseInt(btn.attr('data-step')),
            nextStep = currentStep + 1,
            maxStep = parseInt(btn.attr('data-max'));
        if (btn.hasClass('disabled')){
            return false;
        }
        if (nextStep == 3 && $('.subscribe_step[data-step="3"]').length == 0) {
            nextStep = 4;
        }
        $mainPrevBtn.attr('data-step', currentStep).removeClass('hide');
        if (nextStep == maxStep){
            addProductsToConfirm();
            calcCurrentTotal();
        } else if (nextStep == maxStep - 1) {
            $('.current-total').addClass('with-frequency');
        }
        goToStep(nextStep, currentStep);
        btn.attr('data-step', nextStep);
        $('.subscribe_step[data-step="' + (nextStep + 1) + '"]').removeClass('disabled');
    });

    $mainPrevBtn.on('click', function () {
        let btn = $(this),
            nextStep = parseInt(btn.attr('data-step')),
            currentStep = nextStep + 1,
            maxStep = parseInt(btn.attr('data-max'));
        if (nextStep == 3 && $('.subscribe_step[data-step="3"]').length == 0) {
            nextStep = 2;
        }
        $mainNextBtn.attr('data-step', nextStep);
        goToStep(nextStep, currentStep);
        btn.attr('data-step', nextStep - 1);
    });

    function goToStep(nextStep, currentStep) {
        $('.top-message').hide();
        $('.subscribe_step[data-step="' + nextStep + '"]').addClass('active').prev().addClass('active');
        if ($('.subscribe_step[data-step="' + nextStep + '"]').next().hasClass('active')){
            $('.subscribe_step[data-step="' + nextStep + '"]').next().removeClass('active').next().removeClass('active');
        }
        $('.subscribe-page-wrapper').attr('step', nextStep);
        updateQueryStringParam('step', $('.subscribe_step[data-step="' + nextStep + '"]').attr('data-name'));
        $("html, body").animate({ scrollTop: 0 }, "fast");
        changeButtonClass();
    }

    /* Add subscription to cart */
    var subscriptionProducts = [],
        updateSubscriptionProducts = [],
        initial_price = $addSubscriptionBtn.attr('data-subscription-total'),
        subscriptionId = $addSubscriptionBtn.attr('data-subscription-id'),
        subscriptionUpdateUrl = $addSubscriptionBtn.attr('data-subscription-update-url'),
        subscriptionUrl = $addSubscriptionBtn.attr('data-subscription-url'),
        update = $addSubscriptionBtn.attr('data-update-subscription') == 'yes' ? true : false;
    $('.add-subscription-btn').on('click', function () {
        $('.top-message').hide();
        var extraProducts = false;

        /* Check if button inside popup or not */

        /* if not - push products to array */
        if (!$(this).hasClass('popup-subscription-btn')) {
            getSubscriptionProducts(function () {
                /* check if there are any extra product. If no extra - show popup, else -  add or update subscription*/
                if (subscriptionId && currentTotal != initial_price) {
                    $('.updated_price').text(theme.Currency.formatMoney(currentTotal, theme.strings.moneyFormat));
                    $('#update-price-popup').fadeIn(500);
                }
                else if (!extraProducts && offersEnabled) {
                    $('#add-cart-popup').fadeIn(500);
                }
                else {
                    $('#loading-overlay').fadeIn(500);
                    addOrUpdate();
                }
            });
        }
        /* if button inside popup - just add or update subscription (without extra checking) */
        else {
            $('#loading-overlay').fadeIn(500);
            addOrUpdate();
        }

        function addOrUpdate() {
            /* if updating of subscription in cart - first remove all subscriptions products from cart, then add new subscription */
            if (update) {
                removeSubscription(addSusbcriptionToCart);
            }
            /* if it's a first adding to subscription - just add to cart (without removing)*/
            else {
                addSusbcriptionToCart();
            }
        }

        function getSubscriptionProducts(callback) {
            /* first clear existing array */
            subscriptionProducts = [];
            // updateSubscriptionProducts = [];
            /* push to array all subscription products with line properties*/
            $('.subscription-product-active:not(".hide")').each(function () {
                let $this = $(this);
                if (!$this.hasClass('subscription-product-template')) {
                    var variantId = $this.attr('data-variant-id');
                    var variantQnt = parseInt($this.find('.qnt-input').val());
                    var lineProp = {};
                    lineProp[gwa.settings.subscriptionAttr] = 'yes';
                    lineProp['shipping_frequency'] = $('#shipping-frequency').val();
                    if ($(this).attr('data-main-product') == 'yes') {
                        lineProp['gwa_subscription_main'] = 'yes';
                        // variantQnt = gwa.settings.subscriptionQuantity;
                    }
                    if ($(this).attr('data-extra-product') == 'yes') {
                        extraProducts = true;
                    }
                    if (subscriptionId) {
                        lineProp['gwa_subscription_id'] = subscriptionId;
                    }
                    if (variantQnt > 0) {
                        subscriptionProducts.push({
                            id: variantId,
                            quantity: variantQnt,
                            properties: lineProp
                        });
                    }
                }
            });
            // Clone subscriptionProducts array to updateSubscriptionProducts
            updateSubscriptionProducts = subscriptionProducts.slice(0);
            callback();
        }
        function addSusbcriptionToCart() {
            //let footerOffset = $('#shopify-section-footer').offset().top;
            // If we still have items in the array of products, let's process the next one.
            if (subscriptionProducts.length) {
                /* take one product from array and add it to cart */
                var product = subscriptionProducts.shift();
                //console.log('addSusbcriptionToCart', product);
                $.ajax({
                    type:     'POST',
                    url:      '/cart/add.js',
                    data:     product,
                    dataType: 'json',
                    success:  function () {
                        addSusbcriptionToCart();
                    },
                    error:    function (XMLHttpRequest, textStatus) {
                        console.log(XMLHttpRequest, textStatus);
                        $('#loading-overlay').fadeOut(500);
                        $('#add-cart-popup').fadeOut(200);
                        $('#update-price-popup').fadeOut(200);
                        var data = eval('(' + XMLHttpRequest.responseText + ')');
                        if (data.message) {
                            if (data.status === 422) {
                                $("html, body").animate({ scrollTop: 0 }, 1000);
                                $('.top-message-text').text(data.description);
                                $('.top-message').slideDown(300);
                            }
                        }
                    }
                });
            }
            // Update if subscription id is present
            else if (subscriptionId) {
                //console.log('subscriptionId', subscriptionId, updateSubscriptionProducts);
                $.ajax({
                    type: 'POST',
                    url: subscriptionUpdateUrl,
                    data: {
                        id: subscriptionId,
                        action: 'update',
                        items: updateSubscriptionProducts
                    },
                    success: function (response) {
                        if (response.status) {
                            /* if update was successful - clear cart  */
                            removeSubscription(function () {
                                window.localStorage.setItem('top-message', 'Subscription updated - products changed');
                                window.localStorage.setItem('top-message-time', (new Date().getTime() / 1000).toString());
                                document.location.href = subscriptionUrl;
                            });
                        } else {
                            $('#loading-overlay').fadeOut(500);
                            $('#add-cart-popup').fadeOut(200);
                            $('#update-price-popup').fadeOut(200);
                            $("html, body").animate({ scrollTop: 0 }, 1000);
                            $('.top-message-text').text('Something went wrong. Please try again!');
                            $('.top-message').slideDown(300);
                            console.error('Fail subscription update: ', response.errors.toString());
                        }
                    }
                });
            }
            // If the array is empty, we will redirect to the cart page.
            else {
                let checkSubscribeUrl = $('#checkSubscribeUrl');
                let url = checkSubscribeUrl.length > 0 ? checkSubscribeUrl.val() : '/cart';
                document.location.href = url;
            }
        }
    });

    function removeSubscription(callback) {
        var cartQntArray = [];
        $.ajax({
            type:     'GET',
            url:      '/cart.js',
            dataType: 'json',
            success:  function (cart) {
                for (i = 0; i < cart.items.length; i++) {
                    if (cart.items[i].properties && cart.items[i].properties.gwa_subscription == 'yes') {
                        cartQntArray.push(0);
                    }
                    else {
                        cartQntArray.push(cart.items[i].quantity)
                    }
                }
                $.ajax({
                    type:     'POST',
                    url:      '/cart/update.js',
                    data:     {updates: cartQntArray},
                    dataType: 'json',
                    success:  function () {
                        callback();
                    },
                    error:    function (XMLHttpRequest, textStatus) {
                        $('#loading-overlay').fadeOut(500);
                        $('#add-cart-popup').fadeOut(200);
                        $('#update-price-popup').fadeOut(200);
                        $("html, body").animate({ scrollTop: 0 }, 1000);
                        $('.top-message-text').text('Something went wrong. Please try again!');
                        $('.top-message').slideDown(300);
                        console.log(XMLHttpRequest, textStatus);
                    }
                });
            }
        });
    }


    /* Popup - click on "Let's have a look" button */
    $('#back-to-subscription-btn').on('click', function() {
        $(this).closest('.animatedModal').fadeOut(200);
        if ($('.subscribe-breadcrumbs_wrapper').length > 0) {
            $('.subscribe_step[data-step="' + 4 + '"]').removeClass('active').prev().removeClass('active');
            $mainPrevBtn.attr('data-step', 1);
            goToStep(2, 4);
            $mainNextBtn.attr('data-step', 2);
        } else {
            var headerHeight = 0;
            if ($(window).width() > 768) {
                headerHeight = 111
            }
            $("html, body").animate({ scrollTop: $('.section-subscribe-offers').offset().top - headerHeight }, 1000);
        }
    });

    /* Show more skincare products on mobile */
    $('.show-more-products').on('click', function () {
        $(this).hide();
        $('.subscription-product-hidden').slideDown(500, function () {
            /* calculate again heights for fixed subscription button */
            let footerOffset = $('#shopify-section-footer').offset().top;
            let windowHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
        });
    });

    /* Remove subscription on cart page */
    $('#remove-subscription').on('click', function () {
        removeSubscription(function () {
            location.reload();
        });
    });
});
